import { render, staticRenderFns } from "./PatientInterpretationAppoInfo.vue?vue&type=template&id=e1a32810&"
import script from "./PatientInterpretationAppoInfo.vue?vue&type=script&lang=js&"
export * from "./PatientInterpretationAppoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports